// Kürzel-Übersicht (UX §2.9), geöffnet über „?“ oder das Avatar-Menü.
import { Kbd } from '@bar/ui/basis';
import { X } from '@phosphor-icons/react';
import { Dialog } from 'radix-ui';
import type { PlatformKey } from '@web/registry/types';

const COMMON: [string, string][] = [
  ['⌘K / Ctrl K, /', 'Search and commands'],
  ['?', 'Keyboard shortcuts'],
  ['Esc', 'Close sheet, dialog or panel'],
];

const BY_PLATFORM: Record<PlatformKey, [string, string][]> = {
  people: [
    ['⌘J', 'Open or close chat'],
    ['g h · g p · g g', 'Go to Home, People, Goals'],
    ['g r · g t · g c', 'Go to Rewards, Tech, Chat'],
    ['g a', 'Open Bar AI'],
  ],
  admin: [['g a', 'Open Bar AI']],
  ai: [
    ['⌘⇧O', 'New chat'],
    ['⌘⇧S', 'Show or hide the chat list'],
    ['⌘⇧C', 'Copy last answer'],
    ['Enter · Shift Enter', 'Send · New line'],
  ],
};

export function ShortcutsDialog({
  platform,
  open,
  onOpenChange,
}: {
  platform: PlatformKey;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const rows = [...COMMON, ...BY_PLATFORM[platform]];
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-(--bar-z-dialog) bg-scrim data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed top-1/2 left-1/2 z-(--bar-z-dialog) w-[min(560px,calc(100vw-32px))] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-card p-6 shadow-3 data-[state=open]:animate-pop-in data-[state=closed]:animate-pop-out"
        >
          <div className="flex items-center justify-between gap-3">
            <Dialog.Title className="text-title-detail text-fg">Keyboard shortcuts</Dialog.Title>
            <Dialog.Close
              aria-label="Close"
              className="inline-flex size-8 items-center justify-center rounded-full text-fg-secondary hover:bg-pill-card hover:text-fg"
            >
              <X size={18} aria-hidden />
            </Dialog.Close>
          </div>
          <dl className="mt-4 flex flex-col">
            {rows.map(([keys, label]) => (
              <div
                key={keys}
                className="flex min-h-11 items-center justify-between gap-4 border-b border-line-subtle last:border-0"
              >
                <dt className="text-body text-fg">{label}</dt>
                <dd className="flex shrink-0 gap-1">
                  {keys.split(' · ').map((k) => (
                    <Kbd key={k}>{k}</Kbd>
                  ))}
                </dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-label text-fg-tertiary">
            Single-key shortcuts never fire while you type in a field.
          </p>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
